import { render, staticRenderFns } from "./quizModulePageNew3.vue?vue&type=template&id=5f45e1c9&scoped=true&"
import script from "./quizModulePageNew3.vue?vue&type=script&lang=js&"
export * from "./quizModulePageNew3.vue?vue&type=script&lang=js&"
import style0 from "./quizModulePageNew3.vue?vue&type=style&index=0&id=5f45e1c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45e1c9",
  null
  
)

export default component.exports